import { FC, JSX, ReactNode } from "react";

interface TimelineEventProps {
  children: ReactNode;
  icon: JSX.Element;
  size?: "small" | "medium";
  subtitle: string;
  title: string;
}

export const TimelineEvent: FC<TimelineEventProps> = (props: TimelineEventProps) => {
  return (
    <div className={`timeline-event timeline-event--${props.size ?? "medium"}`}>
      <span className="timeline-event__icon">{props.icon}</span>
      <h2 className="timeline-event__title">{props.title}</h2>
      <p className="timeline-event__subtitle">{props.subtitle}</p>
      {props.children !== undefined ? (
        <div className="timeline-event__content">
          {props.children}
        </div>
      ) : null}
    </div>
  );
}